import { render } from "./OutlinedTextArea.vue?vue&type=template&id=1f75aaa4&scoped=true"
import script from "./OutlinedTextArea.vue?vue&type=script&lang=js"
export * from "./OutlinedTextArea.vue?vue&type=script&lang=js"

import "./OutlinedTextArea.vue?vue&type=style&index=0&id=1f75aaa4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f75aaa4"

export default script